import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

/*
 * The one accent action a public page offers, said to whoever is reading it.
 *
 * Every public page hard-coded "create an account". A signed-in player reading
 * /world or /community was invited to register a second time, and the landing
 * page could not be reached at all — which is how the wrong copy survived. The
 * account is the thing they already have; the lobby is the thing they came for.
 */
export function usePrimaryCta() {
  const store = useStore();
  const { t } = useI18n();

  const signedIn = computed(() => store.getters.isAuthenticated);

  return {
    ctaTarget: computed(
      () => (signedIn.value ? { name: 'PlayerHomeDashboard' } : { name: 'Register' })
    ),
    ctaLabel: computed(
      () => (signedIn.value ? t('home.ctaEnter') : t('home.ctaPrimary'))
    ),
  };
}
